import { render } from "./LabeledInput.vue?vue&type=template&id=24bd64fc&scoped=true"
import script from "./LabeledInput.vue?vue&type=script&lang=js"
export * from "./LabeledInput.vue?vue&type=script&lang=js"

import "./LabeledInput.vue?vue&type=style&index=0&id=24bd64fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24bd64fc"

export default script